import { useHistory } from 'react-router';

import Image404 from '../../../assets/images/base/404.png';
import { Page } from '../../../helbest';

const NotFound = () => {
  const history = useHistory();

  return (
    <Page
      address="/"
      back={true}
      className="page-404"
      headerFix
      mobileContainer
      showFooter
      title="نتیجه ای یافت نشد">
      <div className="box404 animated fadeInLeft">
        <img alt="CarFillo" className="animated fadeIn delay-1s" src={Image404} />
      </div>
      <br />
      <p className="animated fadeInRight delay-1s sormei not-found-text">
        متاسفانه صفحه مورد نظر یافت نشد !
      </p>
      <br />
      <button
        className="btn-h40 animated fadeInLeft delay-1s btn btn-red btn-round font-14 h-btn-modi mt-2   pl-4 pr-4"
        onClick={() => history.push('/')}
        type="button">
        صفحه اصلی
      </button>
    </Page>
  );
};

export default NotFound;
